import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { deriveNoopCache } from "./cacheImpl.js";
var CHACHE_EXPIRY = 7 * (24 * 60) * (60 * 1000);
var deriveCache;

function wrapCache(keyStart, cache) {
  return {
    del: function del(partial) {
      return cache.del("".concat(keyStart).concat(partial));
    },
    forEach: cache.forEach,
    get: function get(partial) {
      var key = "".concat(keyStart).concat(partial);
      var cached = cache.get(key);

      if (cached) {
        cached.x = Date.now();
        cache.set(key, cached);
        return cached.v;
      }

      return undefined;
    },
    set: function set(partial, v) {
      cache.set("".concat(keyStart).concat(partial), {
        v: v,
        x: Date.now()
      });
    }
  };
}

function clearCache(cache) {
  // clear all expired values
  var now = Date.now();
  var all = [];
  cache.forEach(function (key, _ref) {
    var x = _ref.x;
    now - x > CHACHE_EXPIRY && all.push(key);
  }); // don't do delete inside loop, just in-case

  all.forEach(function (key) {
    return cache.del(key);
  });
}

export function setDeriveCache() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cache = arguments.length > 1 ? arguments[1] : undefined;
  deriveCache = cache ? wrapCache("derive:".concat(prefix, ":"), cache) : deriveNoopCache;

  if (cache) {
    clearCache(cache);
  }
}
setDeriveCache();
export { deriveCache };